import { Callout, ConfirmationModal, Typography } from 'seagull';
import ExternalLinkButton from "../ExternalLinkButton";
import styles from "./ConfirmExternallySignModal.module.scss";
import { helpArticles } from "../../utils/helpArticles";
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
export default function ConfirmExternallySignModal(props) {
  const {
    bulkData,
    hasBilledImmediatelyService,
    dismissModal
  } = props;
  const hasMultipleClients = !!bulkData && bulkData.numClients > 1;
  return /*#__PURE__*/_jsx(ConfirmationModal, {
    title: bulkData ? 'Approve on behalf of clients in bulk' : 'Approve on behalf of the client',
    textAlignCenter: false,
    width: "750px",
    content: /*#__PURE__*/_jsxs("div", {
      className: styles.confirmExternallySigned,
      children: [/*#__PURE__*/_jsxs(Typography, {
        children: ["By approving this action on behalf of your client, you represent and warrant that you have obtained full and valid authorization from", hasMultipleClients ? " these ".concat(bulkData.numClients, " clients") : ' the client', " and assume all responsibility for billing them in accordance with the terms, conditions, and provisions of the agreement created on Anchor."]
      }), /*#__PURE__*/_jsx(Typography, {
        children: "Note the following:"
      }), /*#__PURE__*/_jsx(Typography, {
        as: "ul",
        children: ["The approved agreement will not include the client's digital signature.", "Invoices will be issued according to the agreement terms but will only be processed after a payment method is added by you or the client.", "The client will not be notified of this action; however, any future notifications related to this agreement will be sent to the client based on your notification settings."].map((text, idx) => /*#__PURE__*/_jsxs("li", {
          className: styles.bullet,
          children: [/*#__PURE__*/_jsx("span", {}), text]
        }, idx))
      }), /*#__PURE__*/_jsxs(Callout, {
        children: [/*#__PURE__*/_jsx(ExternalLinkButton, {
          openInNewTab: true,
          href: helpArticles.onboardingExistingClients(),
          children: "Learn more"
        }), ' ', "about best practices for transitioning existing clients to Anchor."]
      }), hasBilledImmediatelyService && /*#__PURE__*/_jsx(Callout, {
        intent: "warning",
        "data-testid": "immediately-issued-warning",
        children: "As this proposal includes a service that is set to be billed upon acceptance, an invoice will be issued immediately."
      })]
    }),
    primaryButtonLabel: hasMultipleClients ? 'Approve on behalf of clients' : 'Approve on behalf of the client',
    primaryButtonTestid: "confirm-externally-sign",
    secondaryButtonLabel: "Cancel",
    secondaryButtonTestid: "cancel-externally-sign",
    onPrimaryButtonClick: () => dismissModal(true),
    onSecondaryButtonClick: () => dismissModal(false)
  });
}